import { gql } from "apollo-boost"

export const UPDATE_LOCKED_ASSISTANCE_DATES = gql`
  mutation updateLockedAssistanceDates(
    $submissionSettingsId: ID!,
    $lockedAssistanceDates: [LockedAssistanceDateInput!]!
  ) {
    UpdateLockedAssistanceDates(
      submissionSettingsId: $submissionSettingsId
      lockedAssistanceDates: $lockedAssistanceDates
    ) {
      year
      month
      lockAllActivities
      allowedActivities
      lockedActivities
    }
  }
`
